import { useMutation } from "@tanstack/react-query";
import { Patient, PatientControllerApi } from "../services";
import { getConfigObject } from "../utils/utils";

/**
 *
 * @author rajkumar rathod
 */
interface Params {
  patient: Patient;
  xTENANTID?: string;
}

export const useAddPatient = () =>
  useMutation({
    mutationKey: ["edit-patient"],
    mutationFn: async (params: Params) =>
      new PatientControllerApi(getConfigObject()).createPatient(
        params.patient,
        params.xTENANTID
      ),
  });
